<script>
import SkiPassService from '../../../services/ski/ski-pass-service';

export default {
  name: 'SkiPassPriceImportModal',
  props: {
    seasonId: { type: [ Number, String ], required: true },
    seasonStartYear: { type: Number, required: true },
    hasExistingPeriods: { type: Boolean, default: false },
    netOrGross: { type: String, default: 'gross' },
  },
  data() {
    return {
      open: false,
      file: null,
      requireKeyCard: true,
      rate: 0,
      loading: false,
      error: '',
      summary: null,
    };
  },
  computed: {
    rateLabel() {
      return this.netOrGross === 'net' ? 'Contribution (all prices)' : 'Commission (all prices)';
    },
  },
  methods: {
    onFileChange(event) {
      this.file = event.target.files[0] || null;
    },
    submit() {
      if (!this.file) {
        this.error = 'Please choose an .xlsx file';
        return;
      }
      this.loading = true;
      this.error = '';
      this.summary = null;
      const fd = new FormData();
      fd.append('file', this.file);
      fd.append('seasonStartYear', this.seasonStartYear);
      fd.append('requireKeyCard', this.requireKeyCard ? 1 : 0);
      fd.append('rate', this.rate || 0);
      SkiPassService.importPrices(this.seasonId, fd)
        .then(res => {
          this.summary = res.data;
          this.$emit('imported');
          this.loading = false;
        })
        .catch(err => {
          // Backend 4xx errors return { identifier, data }, where `data` holds the
          // human reason (e.g. the conflict message). 500s only carry an identifier.
          const body = (err.response && err.response.data) || {};
          this.error = (typeof body.data === 'string' && body.data)
            || body.message
            || body.identifier
            || 'Import failed';
          this.loading = false;
        }); // eslint-disable-line vue/script-indent
    },
  },
};
</script>

<template>
  <div class="d-inline-block">
    <v-btn color="primary" outline @click="open = true">Import prices from Excel</v-btn>
    <v-dialog v-model="open" max-width="560">
      <v-card class="pa-3">
        <h3>Import ski pass prices</h3>
        <p class="caption">
          Uploads only the "N dagar SkiPass {resort}" sheets. The season and person
          categories must already exist; categories are matched by name.
          The sheet dates have no year — the year is taken from the season's "From" date
          (autumn dates use that year, spring dates the next), so make sure it is correct.
        </p>
        <v-alert
          v-if="hasExistingPeriods"
          :value="true"
          color="warning"
          outline
          class="mb-3"
        >
          This season already has price periods. Importing will <strong>replace</strong> them —
          the existing prices will be deleted.
        </v-alert>
        <input type="file" accept=".xlsx" @change="onFileChange" >
        <v-text-field
          v-model.number="rate"
          :label="rateLabel"
          type="number"
          min="0"
          hint="Applied to every imported price. Default 0."
          persistent-hint
          class="mt-4"
          style="max-width: 160px"
        />
        <v-switch v-model="requireKeyCard" label="Require key card" />
        <v-alert
          v-if="error"
          :value="true"
          color="error"
          outline
        >{{ error }}</v-alert>
        <v-alert
          v-if="summary"
          :value="true"
          color="success"
          outline
        >
          {{ summary.resort }}: created {{ summary.periodsCreated }} periods,
          {{ summary.pricesCreated }} prices.
          <div v-if="summary.unmatchedLabels && summary.unmatchedLabels.length" class="mt-2">
            <strong>Unmatched categories (skipped):</strong>
            {{ summary.unmatchedLabels.join(', ') }}
          </div>
        </v-alert>
        <div class="text-xs-right mt-2">
          <v-btn flat @click="open = false">Close</v-btn>
          <v-btn :loading="loading" color="primary" @click="submit">Upload</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/ski/skipass/SkiPassPriceImportModal.vue